import { FC } from 'react';
import { Button, DatePicker } from 'antd';

import { PlatformForm, TimezoneDropdown } from '@/shared';
import { dayjs } from '@/utilities';

export type DigestCustomScheduleValue = {
    timeOfDay: string;
    timezone: string;
    weekDays: number[];
};

interface CustomDigestScheduleProps {
    disabled?: boolean;
    onChange: (value: DigestCustomScheduleValue) => void;
    value: DigestCustomScheduleValue;
}

const weekDays = [
    { label: 'S', value: 0 },
    { label: 'M', value: 1 },
    { label: 'T', value: 2 },
    { label: 'W', value: 3 },
    { label: 'T', value: 4 },
    { label: 'F', value: 5 },
    { label: 'S', value: 6 },
];

const parseTimeOfDay = (value: string) => {
    const parsed = dayjs(value, 'HH:mm', true);

    return parsed.isValid() ? parsed : dayjs('08:00', 'HH:mm');
};

const CustomDigestSchedule: FC<CustomDigestScheduleProps> = ({ disabled, onChange, value }): JSX.Element => {
    const toggleWeekDay = (day: number) => {
        const nextWeekDays = value.weekDays.includes(day)
            ? value.weekDays.filter((candidate) => candidate !== day)
            : [...value.weekDays, day].sort((a, b) => a - b);

        onChange({ ...value, weekDays: nextWeekDays.length ? nextWeekDays : [day] });
    };

    return (
        <div style={{ marginTop: '0.75rem' }}>
            <PlatformForm component={false}>
                <PlatformForm.Item label='Time' style={{ marginBottom: '0.5rem', maxWidth: '100%', width: '12rem' }}>
                    <DatePicker.TimePicker
                        disabled={disabled}
                        format='h:mm a'
                        size='small'
                        style={{ width: '100%' }}
                        use12Hours
                        value={parseTimeOfDay(value.timeOfDay)}
                        onChange={(time) => {
                            if (time) {
                                onChange({ ...value, timeOfDay: time.format('HH:mm') });
                            }
                        }}
                    />
                </PlatformForm.Item>
                <PlatformForm.Item
                    label='Timezone'
                    style={{ marginBottom: '0.5rem', maxWidth: '100%', width: '20rem' }}
                >
                    <TimezoneDropdown
                        disabled={disabled}
                        size='small'
                        value={value.timezone}
                        onChange={(timezone) => onChange({ ...value, timezone })}
                    />
                </PlatformForm.Item>
                <PlatformForm.Item label='Days' style={{ marginBottom: 0, maxWidth: '100%', width: '18rem' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                        {weekDays.map((day) => (
                            <Button
                                key={day.value}
                                disabled={disabled}
                                size='small'
                                type={value.weekDays.includes(day.value) ? 'primary' : 'default'}
                                style={{ minWidth: '2rem' }}
                                onClick={() => toggleWeekDay(day.value)}
                            >
                                {day.label}
                            </Button>
                        ))}
                    </div>
                </PlatformForm.Item>
            </PlatformForm>
        </div>
    );
};

export default CustomDigestSchedule;
